// get products
function generateRandomNumbers(limit, length) {
  var numbers=[];
  while (numbers.length<limit) {
    var randomNumber = Math.floor(Math.random() * length+1);
    if (!numbers.includes(randomNumber)) {
      numbers.push(randomNumber);
    }
  }
  return numbers;
}

export const getProducts = (products, category, type, limit, productid) => {
  const finalProducts = category
    ? products.filter(
        product => product.category.filter(single => single === category && productid!==product.id && product.visible)[0]
      )
    : products;
  if (type && (type === "recommended" || type=== "recentviewed") )    {
     return products;
  }
  if (type && type === "new") {
    const newProducts = finalProducts.filter(single => single.new && single.visible);
    return newProducts.slice(0, limit ? limit : newProducts.length);
  }
  if (type && type === "bestSellers") {
    const bestSeller=finalProducts.filter(single => single?.saleCount>0 && single?.saleCount<=100);
    return bestSeller
      .sort((a, b) => {
        return b.saleCount - a.saleCount;
      })
      .slice(0, limit ? limit : bestSeller.length);
  }
  if (type && type === "saleItems") {
    const saleItems = finalProducts.filter(
      single => (single.discount && single.discount > 0) || single?.enjoy===1 && single.visible
    );
    return saleItems
      .sort((a, b) => {
      return b.specCount - a.specCount;
     })
    .slice(0, limit ? limit : saleItems.length);
  }
  if (productid===undefined || limit+3 > finalProducts.length)
   return finalProducts.slice(0, limit ? limit : finalProducts.length);
  else
  {
    var randomNumbers=generateRandomNumbers(limit,finalProducts.length)
    return finalProducts.filter(function(_, index) {
      return randomNumbers.includes(index);
    })
  }
};

// get product discount price
export const getDiscountPrice = (price, discount) => {
  return discount && discount > 0 ? price - price * (discount / 100) : null;
};

// get product cart quantity
export const getProductCartQuantity = (cartItems, product, color, size) => {
  let productInCart = cartItems.filter(
    single =>
      single.id === product.id &&
      (single.selectedProductColor
        ? single.selectedProductColor === color
        : true) &&
      (single.selectedProductSize ? single.selectedProductSize === size : true)
  )[0];
  if (cartItems.length >= 1 && productInCart) {
    if (product.variation) {
      return cartItems.filter(
        single =>
          single.id === product.id &&
          single.selectedProductColor === color &&
          single.selectedProductSize === size
      )[0].quantity;
    } else {
      return cartItems.filter(single => product.id === single.id)[0].quantity;
    }
  } else {
    return 0;
  }
};

//get products based on category
export const getSortedProducts = (products, sortType, sortValue) => {
  if (products && sortType && sortValue) {
    if (sortType === "name") {
     // console.log(sortType)
        return products.filter(product => {
         return (product.name.toLowerCase().includes(sortValue.toLowerCase()) ||
          product.nameen.toLowerCase().includes(sortValue.toLowerCase()) ||        
          product.id.toLowerCase().includes(sortValue.toLowerCase()) ||
          product.pn.toLowerCase()===sortValue.toLowerCase()) &&
          product.visible;    
        });
    }
   /* if (sortType === "category") {
      return products.filter(
        product => product.catecode.filter(single => single === sortValue && product.visible)[0]
      );
    } */
    if (sortType === "category") {
      return products.filter(
        product =>
          product.visible &&
          Array.isArray(product.catecode) &&
          product.catecode.some(code => code.trim().toLowerCase() === sortValue.trim().toLowerCase())
      );
    }
    if (sortType === "new") {
      return products.filter(single => single.new && single.visible);
    }
    if (sortType === "bestSellers") {
      const bestSeller=products.filter(single => single?.saleCount>0 && single?.saleCount<=100);
      return bestSeller
        .sort((a, b) => {
          return b.saleCount - a.saleCount;
        });
    }    
/*    if (sortType === "saleItems") {
      return products.filter(
        single => (single?.discount > 0) || single?.enjoy===1 && single.visible);
    }  */
    if (sortType === "saleItems") {
      const saleItems = products.filter(
        single => (single.discount > 0) || single?.enjoy===1 && single.visible);
      return saleItems
        .sort((a, b) => {
        return b.specCount - a.specCount;
       })
    //  .slice(0, limit ? limit : saleItems.length);
    }


    if (sortType === "tag") {
     return products.filter(
        product => product.tag.filter(single => single === sortValue && product.visible)[0]
      ); 
    }
    if (sortType === "color") {
      return products.filter(
        product =>
          product.variation &&
          product.variation.filter(single => single.color === sortValue)[0]
      );
    }
    if (sortType === "size") {
      return products.filter(
        product =>
          product.variation &&
          product.variation.filter(
            single => single.size.filter(single => single.name === sortValue)[0]
          )[0]
      );
    }
    if (sortType === "filterSort") {
      let sortProducts = [...products];
      if (sortValue === "default") {
        return sortProducts;
      }
      if (sortValue === "priceHighToLow") {
        return sortProducts.sort((a, b) => {
          return b.price - a.price;
        });
      }
      if (sortValue === "priceLowToHigh") {
        return sortProducts.sort((a, b) => {
          return a.price - b.price;
        });
      }
    }
  }
  //return products;
  return products.filter(
    product => product.visible
  );
};

// get individual element
const getIndividualItemArray = array => {
  let individualItemArray = array.filter(function(v, i, self) {
    return i === self.indexOf(v);
  });
  return individualItemArray;
};

// get individual categories
export const getIndividualCategories = products => {
  let productCategories = [];
  products &&
    products.map(product => {
      return (
        product.category &&
        product.category.map(single => {
          return productCategories.push(single);
        })
      );
    });
  const individualProductCategories = getIndividualItemArray(productCategories);
  return individualProductCategories;
};

export const getIndividualCateimage = products => {
  let productCateimage = [];
  products &&
    products.map(product => {
      return (
        product.cateimage &&
        product.cateimage.map(single => {
          return productCateimage.push(single);
        })
      );
    });
  const individualProductCateimage = getIndividualItemArray(productCateimage);
  return individualProductCateimage;
};

export const getIndividualCate = products => {  
  let acate=[];
  products &&
  products.reduce((acc,product) => {
    if (!acc[product.catecode]) {
      acc[product.catecode] = {
        catecode: product.catecode,
        category: product.category,
        cateimage: product.cateimage,
        categoryen: product.categoryen
      };
      acate.push(acc[product.catecode])
    }
    return acc;
  },{}
  );  
  return acate;
};   

// get individual tags
export const getIndividualTags = products => {
  let productTags = [];
  products &&
    products.map(product => {
      return (
        product.tag &&
        product.tag.map(single => {
          return productTags.push(single);
        })
      );
    });
  const individualProductTags = getIndividualItemArray(productTags);
  return individualProductTags;
};

// get individual colors
export const getIndividualColors = products => {
  let productColors = [];
  products &&
    products.map(product => {
      return (
        product.variation &&
        product.variation.map(single => {
          return productColors.push(single.color);
        })
      );
    });
  const individualProductColors = getIndividualItemArray(productColors);
  return individualProductColors;
};

// get individual sizes
export const getProductsIndividualSizes = products => {
  let productSizes = [];
  products &&
    products.map(product => {
      return (
        product.variation &&
        product.variation.map(single => {
          return single.size.map(single => {
            return productSizes.push(single.name);
          });
        })
      );
    });
  const individualProductSizes = getIndividualItemArray(productSizes);
  return individualProductSizes;
};

// get product individual sizes
export const getIndividualSizes = product => {
  let productSizes = [];
  product.variation &&
    product.variation.map(singleVariation => {
      return (
        singleVariation.size &&
        singleVariation.size.map(singleSize => {
          return productSizes.push(singleSize.name);
        })
      );
    });
  const individualSizes = getIndividualItemArray(productSizes);
  return individualSizes;
};

export const setActiveSort = e => {
  const filterButtons = document.querySelectorAll(
    ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
  );
  filterButtons.forEach(item => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};

export const removeActiveSort = () => {
  const filterButtons = document.querySelectorAll(
    ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
  );
  filterButtons.forEach(item => {
    item.classList.remove("active");
  });   
}

export const setActiveLayout = e => {
  const gridSwitchBtn = document.querySelectorAll(".shop-tab button");
  gridSwitchBtn.forEach(item => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
  
};

export const toggleShopTopFilter = e => {
  const shopTopFilterWrapper = document.querySelector(
    "#product-filter-wrapper"
  );
  shopTopFilterWrapper.classList.toggle("active");
  if (shopTopFilterWrapper.style.height) {
    shopTopFilterWrapper.style.height = null;
  } else {
    shopTopFilterWrapper.style.height =
      shopTopFilterWrapper.scrollHeight + "px";
  }
  e.currentTarget.classList.toggle("active");
};
